export const BASE16_RADIX: number = 16;

export const JSON_STRINGIFY_SPACES: number = 2;

export const DEFAULT_LIST_PAGE_SIZE: number = 25;
